import queryString from 'query-string';
import http from '.';
import { apiCeus } from './apiRouter';

const getListCeu = (body) => {
  const params = queryString.stringify(body);
  return http.get(`${apiCeus}?${params}`);
};

const addCEU = (body) => {
  return http.post(`${apiCeus}`, body);
};

const updateCEU = ({ id, body }) => {
  return http.put(`${apiCeus}/${id}`, body);
};

const deleteCeus = (courseScheduleUserId) => {
  return http.delete(`${apiCeus}/${courseScheduleUserId}`);
};

const getInfo = (id) => {
  return http.get(`${apiCeus}/${id}`);
};

const importCEUs = (formData) => {
  return http.post(`${apiCeus}/import`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const CeuServices = {
  getListCeu,
  updateCEU,
  deleteCeus,
  addCEU,
  getInfo,
  importCEUs,
};

export default CeuServices;
